import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../context/AuthContext";
import io from "socket.io-client";
import axios from "../utils/api";
import ChatWindow from "../components/ChatWindow";
import UserList from "../components/UserList";

const socket = io("http://localhost:5000");

export default function ChatPage() {
    const { user } = useContext(AuthContext);
    const [messages, setMessages] = useState([]);
    const [onlineUsers, setOnlineUsers] = useState([]);
    const [typingUser, setTypingUser] = useState("");

    useEffect(() => {
        if (user) socket.emit("online", user.username);

        socket.on("message", (msg) => {
            setMessages((prev) => [...prev, msg]);
        });

        socket.on("onlineUsers", (users) => {
            setOnlineUsers(users);
        });

        socket.on("typing", (username) => {
            setTypingUser(username);
            setTimeout(() => setTypingUser(""), 1000);
        });

        return () => socket.disconnect();
    }, [user]);

    useEffect(() => {
        axios.get("/messages").then((res) => setMessages(res.data));
    }, []);

    return (
        <div className="chat-page">
            <UserList users={onlineUsers} />
            <ChatWindow
                messages={messages}
                socket={socket}
                typingUser={typingUser}
                user={user}
            />
        </div>
    );
}